module.exports = __webpack_public_path__ + "img/bg-paid-removebg-preview.44667d59.png";